import Account          from "../../../domain/account/Account";
import ResKaReduxAction from "../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_ACCOUNT = "SET_ACCOUNT"
}

export interface SetAccountAction extends ResKaReduxAction {
  account: Account;
}

export type AccountAction = SetAccountAction;

export const setAccountAction = (account: Account): SetAccountAction => ({
  type: ACTION_TYPE.SET_ACCOUNT,
  account: account,
});